// extracted by mini-css-extract-plugin
export default {"scroll-area":"styles__scroll-area--5SLzn","scroll-area-content":"styles__scroll-area-content--rmf0E"};